import { withProps } from "recompose";
import { Box } from "src/components/base";

const FullWidth = withProps({
  mx: [-3],
})(Box);

export default FullWidth;



// WEBPACK FOOTER //
// ./src/components/FullWidth.js